module.exports = __webpack_public_path__ + "img/ic_list_chat_white.26e5caa7.svg";